<template>
  <VRow class="kanban-actions">
    <VCol class="d-flex pr-md-3 pl-3 kanban-actions__wrap">
      <VBtn
        id="invite-candidate-btn"
        color="success"
        class="mb-3 mr-3"
        @click.stop="createCandidateDialog = true"
      >
        {{ $t('inviteCandidate') }}
      </VBtn>

      <AppDialog v-model="interviewDialog" transition="slide-y-transition" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <VBtn
            class="purple"
            color="success mr-3 mb-3"
            dark
            v-bind="attrs"
            v-on="on"
          >
            {{ $t('recordInterview') }}
          </VBtn>
        </template>

        <div class="modal relative">
          <h4 class="modal__heading">
            {{ $t('recordInterview') }}
          </h4>

          <VList class="modal__list">
            <VListItem
              v-for="(item, i) in selectItems"
              :key="i"
              class="modal__list-item modal__list-btn"
              @click="recordInterview(item.value)"
            >
              <h4 class="modal__list-item-heading">
                {{ item.label }}
              </h4>

              <p class="modal__list-item-hint">
                {{ item.description }}
              </p>
            </VListItem>
          </VList>
        </div>
      </AppDialog>
      <VBtn
        class="v-btn grey lighten-5 text--color--dark grey-btn"
        @click="toggleOperationsEnabled"
      >
        <template v-if="operationsEnabled">
          {{ $t('done') }}
        </template>
        <template v-else>
          {{ $t('groupOperations') }}
        </template>
      </VBtn>
      <VMenu
        class="kanban-settings"
        v-if="isKanbanDataReady"
        bottom
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <VBtn
            v-bind="attrs"
            v-on="on"
            color="#1fc57f"
            width="40px"
            class="kanban-settings-btn"
          >
            <VIcon>
              mdi-cog
            </VIcon>
          </VBtn>
        </template>

        <VList class="kanban-settings">
          <VListItem class="kanban-settings-item">
            <a href="#" @click.prevent="$emit('addStage')">{{ $t('addStage') }}</a>
          </VListItem>
          <VListItem class="kanban-settings-item">
            <a href="#" @click.prevent="$emit('showHiddenStages')">
              {{ showHidden ? $t('hideHidden') : $t('showHidden') }}</a>
          </VListItem>
          <VListItem class="kanban-settings-item">
            <a href="#" @click.prevent="$emit('showAllStages')">
              {{ isShowAllStages ? $t('hideAllStages') : $t('showAllStages') }}</a>
          </VListItem>
        </VList>
      </VMenu>
    </VCol>
  </VRow>
</template>

<script>
import useKanbanDialogs from '@/compositions/useKanbanDialogs';
import { useI18n } from 'vue-i18n-composable';
import { candidateInterviewType } from '@/enums';
import { ref } from '@vue/composition-api';
import AppDialog from '@/components/AppDialog.vue';
import { useKanbanMultipleOperations } from '@/compositions/useKanbanMultipleOperations';

export default {
  name: 'VacancyCandidatesKanbanActions',
  components: { AppDialog },
  props: {
    isKanbanDataReady: {
      type: Boolean,
      required: true,
    },
    showHidden: {
      type: Boolean,
      required: true,
    },
    isShowAllStages: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const {
      recordOfficeInterviewDialog,
      createCandidateDialog,
      createVideoCallDialog,
    } = useKanbanDialogs();
    const selectItems = ref([
      {
        label: t(candidateInterviewType.VIDEO_CALL),
        value: candidateInterviewType.VIDEO_CALL,
        description: t(`${candidateInterviewType.VIDEO_CALL}_description`),
      },
      {
        label: t(candidateInterviewType.OFFICE_INTERVIEW),
        value: candidateInterviewType.OFFICE_INTERVIEW,
        description: t(`${candidateInterviewType.OFFICE_INTERVIEW}_description`),
      },
    ]);
    const { toggleOperationsEnabled, operationsEnabled } = useKanbanMultipleOperations();
    const selectedCreateType = ref(null);
    const selectKey = ref(Date.now());
    const interviewDialog = ref(false);
    return {
      createVideoCallDialog,
      recordOfficeInterviewDialog,
      createCandidateDialog,
      selectItems,
      selectedCreateType,
      selectKey,
      interviewDialog,
      toggleOperationsEnabled,
      operationsEnabled,
    };
  },
  methods: {
    recordInterview(value) {
      const selectedValue = value;
      // const selectedValue = this.selectedCreateType;
      this.selectedCreateType = null;
      this.selectKey = Date.now();
      switch (selectedValue) {
        case candidateInterviewType.OFFICE_INTERVIEW: {
          this.recordOfficeInterviewDialog = true;
          break;
        }
        case candidateInterviewType.VIDEO_CALL: {
          this.createVideoCallDialog = true;
          break;
        }
        default: {
          break;
        }
      }
      this.interviewDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  background: white;
  padding: 56px 50px;
  &__heading {
    font-size: 1.3rem;
    line-height: 20px;
    margin: 0 0 30px 0;
  }
  &__list {
    padding: 0;
  }
  &__list-item {
    display: block;
    padding: 20px;
    min-height: auto;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    &:first-child {
      margin-bottom: 20px;
    }
    &-hint {
      font-size: calc(1rem - 2px);
      color: #757575;
      margin: 0;
    }
  }
  &__btn {
    border: 1px solid #d6d6d6;
    margin: 0;
    border-radius: 4px;
    font-size: 1rem;
    line-height: 1rem;
  }
}

.kanban-actions {
  @media screen and (max-width: 428px) {
    margin: 12px -12px 0;
  }
  &__wrap {
    @media screen and (max-width: 800px) {
      flex-wrap: wrap !important;
    }
  }
}

.grey-btn {
  margin-right: 10px;
}

.kanban-settings {
  padding: 0.375rem 0;
  .kanban-settings-item {
    font-size: 0.875rem;
    min-height: 1.75rem;
    a {
      text-decoration: none;
    }
  }
}

.kanban-settings-btn {
  min-width: 2.625rem !important;
  min-height: 2.625rem !important;
  @media screen and (max-width: 599px) {
    top: 0;
    right: 0;
    position: absolute;
  }
  @media screen and (max-width: 428px) {
    top: 23px;
    right: 0;
    position: absolute;
  }
}
</style>

<i18n locale="en" lang="yaml">
inviteCandidate: Invite candidate
recordOfficeInterview: Record in-person interview
recordInterview: Record interview
video_call: Create a video call
video_call_description: everything is like in Zoom, the entry will appear in the candidate's card
office_interview: Record an office meeting
office_interview_description: Nice to have when somebody can not attend
groupOperations: Select multiple candidates
done: Done
addStage: Add stage
showHidden: Show hidden
hideHidden: Hide hidden
showAllStages: Show all statuses
hideAllStages: Don't show all statuses
</i18n>

<i18n locale="ru" lang="yaml">
inviteCandidate: Пригласить кандидата
recordOfficeInterview: Записать очное интервью
recordInterview: Записать интервью
office_interview: Записать встречу в офисе
video_call: Создать видеозвонок
groupOperations: Выбрать несколько кандидатов
done: Готово
video_call_description: все как в Zoom, запись появится в карточке кандидата
office_interview_description: пригодится, если кто-то из коллег не может присутствовать
addStage: Добавить статус
showHidden: Показать скрытые
hideHidden: Убрать скрытые
showAllStages: Показать все статусы
hideAllStages: Не показывать все статусы
</i18n>
